// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"bfcc165456a7533e","74724":"b6323009d4472833","96325":"38c66e5325071d3b"}[chunkId] + ".css";
};